import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Button from 'jbc-front/components/Button';
import {
  getConfirmJobs,
  getDownloadPayCsvJobs,
  getImportPayCsvJobs,
  getDashboardSummaryJobs
} from 'src/reducers/employees/employeePays';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getExtras } from 'src/reducers/common/listReducer';
import ConfirmPayrollGroupModal from './ConfirmPayrollGroupModal';
import UnconfirmPayrollGroupModal from './UnconfirmPayrollGroupModal';
import styles from './ConfirmPayrollContainer.scss';
import { withTranslation } from 'react-i18next';

class ConfirmPayrollContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isConfirmModalOpen: false,
      isUnconfirmModalOpen: false
    };
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.openUnconfirmModal = this.openUnconfirmModal.bind(this);
    this.closeUnconfirmModal = this.closeUnconfirmModal.bind(this);
  }

  openConfirmModal() {
    if (this.state.isConfirmModalOpen) return;
    this.setState({ ...this.state, isConfirmModalOpen: true });
  }

  closeConfirmModal() {
    if (!this.state.isConfirmModalOpen) return;
    this.setState({ ...this.state, isConfirmModalOpen: false });
  }

  openUnconfirmModal() {
    if (this.state.isUnconfirmModalOpen) return;
    this.setState({ ...this.state, isUnconfirmModalOpen: true });
  }

  closeUnconfirmModal() {
    if (!this.state.isUnconfirmModalOpen) return;
    this.setState({ ...this.state, isUnconfirmModalOpen: false });
  }

  isPayReportsCreating() {
    const downloadObjVi = _.get(_.find(this.props.uniquePaymentDates, { value: this.props.selectedYearMonth }), 'downloadObjVi');
    const downloadObjEn = _.get(_.find(this.props.uniquePaymentDates, { value: this.props.selectedYearMonth }), 'downloadObjEn');
    
    const statusVi = _.get(downloadObjVi, 'status');
    const statusEn = _.get(downloadObjEn, 'status');

    const includesVi = _.includes(['waiting', 'running'], statusVi);
    const includesEn = _.includes(['waiting', 'running'], statusEn);

    return includesVi || includesEn;
  }

  render() {
    const {
      selectedPayroll,
      selectedYearMonth,
      isConfirmed,
      confirmPayJobs,
      downloadPayCsvJobs,
      importPayCsvJobs,
      uniquePaymentDates,
      dashboardSummaryJobs
    } = this.props;

    const yearMonthLabel = _.get(_.find(uniquePaymentDates, { value: selectedYearMonth }), 'label');
    const hasRunningPayJobs =
      !_.isEmpty(dashboardSummaryJobs.inProgress) ||
      !_.isEmpty(dashboardSummaryJobs.waiting) ||
      !_.isEmpty(confirmPayJobs.inProgress) ||
      !_.isEmpty(confirmPayJobs.waiting) ||
      !_.isEmpty(downloadPayCsvJobs.inProgress) ||
      !_.isEmpty(downloadPayCsvJobs.waiting) ||
      !_.isEmpty(importPayCsvJobs.inProgress) ||
      !_.isEmpty(importPayCsvJobs.waiting);

    // const confirmBtnDisabled = isConfirmed || hasRunningPayJobs;
    const disabledReason = hasRunningPayJobs
      ? this.props.t('features.EmployeePays.components.ConfirmPayrollContainer.processing')
      : null;

    if (!selectedPayroll || !selectedYearMonth) {
      return <Button primary className={styles.button} />;
    }

    let confirmBtn;
    if (isConfirmed) {
      confirmBtn = (
        <Button
          disabled={this.isPayReportsCreating()}
          primary
          onClick={this.openUnconfirmModal}
          className={styles.button}
        >
          {this.props.t('features.EmployeePays.components.ConfirmPayrollContainer.Cancel_confirmation')}
        </Button>
      );
    } else {
      confirmBtn = (
        <Button
          primary
          disabled={hasRunningPayJobs}
          disabledReason={disabledReason}
          onClick={this.openConfirmModal}
          className={styles.button}
        >
          {this.props.t('features.EmployeePays.components.ConfirmPayrollContainer.Salary_confirmation')}
        </Button>
      );
    }

    return (
      <div>
        {confirmBtn}
        <ConfirmPayrollGroupModal
          isOpen={this.state.isConfirmModalOpen}
          hideModal={this.closeConfirmModal}
          {...{ selectedPayroll, selectedYearMonth }}
        />
        <UnconfirmPayrollGroupModal
          isOpen={this.state.isUnconfirmModalOpen}
          hideModal={this.closeUnconfirmModal}
          selectedPayroll={selectedPayroll}
          yearMonthLabel={yearMonthLabel}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  confirmPayJobs: getConfirmJobs(state) || {},
  downloadPayCsvJobs: getDownloadPayCsvJobs(state) || {},
  importPayCsvJobs: getImportPayCsvJobs(state) || {},
  dashboardSummaryJobs: getDashboardSummaryJobs(state) || {},
  uniquePaymentDates: getSelectOptions(state, 'uniquePaymentDates'),
  downloadObj: getExtras('employeePays', state)
});

export default withTranslation()(connect(mapStateToProps)(ConfirmPayrollContainer));
